// RecipeItem.jsx
import React from "react";
import FilledButton from "components/InterstellrComponents/FilledButton";

import { FaPencil } from "react-icons/fa6";
import { FaTrashAlt } from "react-icons/fa";
import { IoCloseSharp, IoCheckmarkSharp } from "react-icons/io5";

const RecipeItem = ({ item, onEditItem, onDelete, onChangeStatus }) => {
  return (
    <div className="flex flex-col border border-slate-300 rounded-lg">
      {item?.image ? (
        <img
          src={item?.image}
          alt={item?.title}
          className="w-full h-48 object-cover rounded-t-lg"
        />
      ) : null}

      <div className="px-3 py-3">
        <h4 className="text-black h-20 font-medium text-base">
          {item?.title ?? ""}
        </h4>

        <p className="text-black font-normal text-base">
          Visible:{" "}
          <span style={{ color: item?.visible ? "green" : "red" }}>
            {item?.visible ? "Yes" : "No"}
          </span>
        </p>
      </div>

      <div className="flex flex-row px-3 pb-3">
        <div className="w-8">
          <FilledButton
            icon={<FaPencil className="text-white" />}
            onPress={() => onEditItem()}
          />
        </div>

        <div className="w-8 ml-2">
          <FilledButton
            backgroundColor="#FF0000"
            icon={<FaTrashAlt className="text-white" />}
            onPress={onDelete}
          />
        </div>

        <div style={{ flex: 1 }} />

        <div className="w-8 ml-2">
          <FilledButton
            backgroundColor={item?.visible ? "red" : "green"}
            onPress={() => onChangeStatus({ itemId: item?._id ?? item?.id })}
            icon={
              item?.visible ? (
                <IoCloseSharp className="text-white" />
              ) : (
                <IoCheckmarkSharp className="text-white" />
              )
            }
          />
        </div>
      </div>
    </div>
  );
};

export default RecipeItem;
